import type { CommandDeckPreviewBundle } from '../contracts/types'

interface Props {
  bundle: CommandDeckPreviewBundle
}

export function CommandDeckAiAdvisor({ bundle }: Props) {
  const primary = bundle.bestNextMove.primary

  return (
    <section className="cd-mc-advisor command-deck-glass" aria-labelledby="cd-mc-advisor-heading">
      <h2 id="cd-mc-advisor-heading">AI Advisor</h2>
      <p className="cd-mc-advisor__title">{primary.title}</p>
      <p className="cd-mc-advisor__body">{primary.summary}</p>
      <p className="cd-mc-advisor__note">Read-only advisory — no auto-execution in this lane.</p>
    </section>
  )
}
